import React from 'react';
import AccountInfoInOutDF from '../components/SimulatorsComponents/DefualtSimulators/AccountInfoInOutDF';
//= ========================================================================
const Sim_C03_AccountInfoInOut = ({
  globJSON,
  language,
  simPlatform,
  slideshowRefs = null,
  selectedScreen,
}) => (
  <AccountInfoInOutDF
    globJSON={globJSON}
    selectedScreen={selectedScreen}
    language={language}
    simPlatform={simPlatform}
    slideshowRefs={slideshowRefs}
  />
);

export default Sim_C03_AccountInfoInOut;
